<template>
    <el-scrollbar :style="{height: winHeight}">
        <table class="bm-table">
            <tr>
                <td class="bm-table-name">Raac ID</td>
                <td class="bm-table-ope">
                    <p class="info-p"> {{raac_info.raac_id}} </p>
                </td>
            </tr>
            
            <tr>
                <td class="bm-table-name">Method</td>
                <td class="bm-table-ope">
                    <p class="info-p"> {{raac_info.method}} </p>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Reduced alphabet</td>
                <td class="bm-table-ope">
                    <RaacView :cluster="raac_info.cluster"></RaacView>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Description</td>
                <td class="bm-table-ope">
                    <p class="info-p">
                        {{raac_info.descriptions | split_image}} 
                        </p>
                </td>
            </tr>
            <tr >
                <td class="bm-table-name">Paper</td>
                <td class="bm-table-ope">
                    <p class="info-p"> {{raac_info.paper}}
                        <a v-if="raac_info.pubmed !== null" :href="`https://pubmed.ncbi.nlm.nih.gov/${raac_info.pubmed}/`" target="_blank"><i class="icon-font icon-dianshang-wailian-77"></i></a>
                    </p>
                </td>
            </tr>            
            <tr v-if="raac_info.author !== null && raac_info.author !== ''">
                <td class="bm-table-name">Author</td>
                <td class="bm-table-ope">
                    <p class="info-p"> {{raac_info.author}} </p>
                </td>
            </tr>
            <tr v-if="raac_info.publist !== null && raac_info.publist !== ''">
                <td class="bm-table-name">Date</td>
                <td class="bm-table-ope">
                    <p class="info-p"> {{raac_info.publist}} </p>
                </td>
            </tr>
             <tr v-if="raac_info.journal !== null && raac_info.journal !== ''">
                <td class="bm-table-name">Journal</td>
                <td class="bm-table-ope">
                    <p class="info-p"> {{raac_info.journal}} </p>
                </td>
            </tr>
            <tr v-if="raac_info.pubmed !== null && raac_info.pubmed !== ''">
                <td class="bm-table-name">PMID</td>
                <td class="bm-table-ope">
                    <p class="info-p">  
                        <a v-if="raac_info.pubmed !== null" :href="`https://pubmed.ncbi.nlm.nih.gov/${raac_info.pubmed}/`" target="_blank">{{raac_info.pubmed}}</a>
                    </p>
                </td>
            </tr>
            <tr v-if="raac_info.source !== null && raac_info.source !== ''">
                <td class="bm-table-name">Source</td>
                <td class="bm-table-ope">
                    <p class="info-p"> 
                        <a :href="raac_info.source" target="_blank">{{raac_info.source | ellipsis}} </a>
                    </p>
                </td>
            </tr>
            <tr v-if="raac_info.doi !== null && raac_info.doi !== ''">
                <td class="bm-table-name">DOI</td>
                <td class="bm-table-ope">
                    <p class="info-p"> 
                        <a :href="`https://doi.org/${raac_info.doi}`" target="_blank">{{raac_info.doi}} </a>
                    </p>
                </td>
            </tr>
        </table>
    </el-scrollbar>
</template>

<script>
    import axios from 'axios';
    import global_ from "../units/Global";
    import RaacView from "../../components/raacview/RaacView.vue";

    export default {
        name: "Raac",
        data(){
            return {
                website: global_.website,
                raac_info: [],
                winHeight: window.innerHeight - 90 + "px",
            }
        },
         components: {
            RaacView
            },
        watch:{
            '$store.state.current_raac_id' (val){
                // console.log(val);
                this.get_raac();
            },
            '$store.state.raac_scheme'(){
                // console.log(this.$store.state.current_raac_id);
                this.get_raac();
            }
        },
        filters:{
            ellipsis(value){
                if (!value) return '';
                if (value.length > 35) {
                    return value.slice(0,35) + '...'
                }
                return value
            },
            split_image(value){
                if (!value) return '';  
                if(value !== "" && value !== undefined)
                if(value.search("<image") != -1)              
                    return value.split(">")[1]
                else
                    return value
            }
        },
        mounted() {
            this.init();
        },
        methods:{
            init(){
                // console.log(this.$store.state.current_raac_id);
                this.get_raac();
            },
            get_raac(){
                let raac_id = this.$store.state.current_raac_id;
                // console.log("raac_id", raac_id)
                if (raac_id === 'Custom'){
                    this.raac_info = {
                        raac_id: 'custome',
                        method: 'custome',
                        descriptions: 'custome',
                        cluster: 'custome',
                        paper: 'custome',
                        author: 'custome',
                        publish: 'custome',
                    }
                }else{
                    let url = `${this.website}/api/raac_scheme_search/raac_id/${raac_id}/`;
                    // console.log(url);
                    axios.get(url).then((res) => {
                        this.raac_info = res.data.results[0];
                        this.$store.commit("raacInfoMutation", this.raac_info);
                        // console.log("this.raac_info", this.raac_info)
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .bm-table-name {
        padding: 5px 0 5px 0;
        width: 90px;
        text-align: center;
    }
    .info-p {
        margin: 2px 8px 2px 8px;
        text-align: justify;
        text-justify:inter-ideograph;
    }
     .el-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #409EFF !important;
     }

</style>
